import React from "react";
import Snackbar from "@mui/material/Snackbar";
import { GeneralContextFunc } from "../Context/GeneralContex";
import Alert from "@mui/material/Alert";

const AlertComp = () => {
  const { alert, resetAlert } = GeneralContextFunc();

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={alert.cond}
      onClose={() => resetAlert()}
      autoHideDuration={3000}
    >
      <Alert
        onClose={() => resetAlert()}
        variant="filled"
        sx={{ width: "100%" }}
        severity={alert.severity}
      >
        {alert.message}
      </Alert>
    </Snackbar>
  );
};

export default AlertComp;
